function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "ICONS/FIGURES/ico-30-reseauEquipmt");

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "ICONS/FIGURES/ico-30-reseauEquipmt"
}, /*#__PURE__*/React.createElement("g", {
  id: "ICONS/\\u2022bg-enjeux",
  transform: "translate(9.000000, 7.000000)",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("rect", {
  id: "bg-w",
  x: 0,
  y: 0,
  width: 12,
  height: 16
})), /*#__PURE__*/React.createElement("g", {
  id: "ICONS/\\u2022bg-enjeux",
  transform: "translate(7.000000, 10.000000)",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("rect", {
  id: "bg-w",
  x: 0,
  y: 0,
  width: 16,
  height: 10
})), /*#__PURE__*/React.createElement("path", {
  d: "M15,0.857864376 L29.1421356,15 L15,29.1421356 L0.857864376,15 L15,0.857864376 Z M7.73679718,16.8759196 C8.57274536,20.1129599 11.5076111,22.5 15,22.5 C16.3209668,22.5 17.5502941,20.7853353 18.1379144,18.2707646 C17.1659569,18.4197514 16.106946,18.5 15,18.5 C11.9316797,18.5 9.23165928,17.8834249 7.73679718,16.8759196 Z M22.2636005,16.8754535 L22.2376348,16.8930356 C21.4888777,17.3909088 20.4443792,17.792154 19.2064748,18.0691783 C18.8805466,19.7007662 18.2991345,21.0938547 17.5405826,22.060524 C19.855882,21.2255352 21.6433158,19.2848007 22.2636005,16.8754535 Z M15,7.5 C10.9390827,7.5 7.63198248,10.7274744 7.50385357,14.7572689 L7.5,15 L7.5,15 C7.5,16.2469373 10.8415006,17.5 15,17.5 C16.2012608,17.5 17.334347,17.3954379 18.3384061,17.2166662 C18.4430815,16.5172604 18.5,15.7732799 18.5,15 C18.5,10.9173787 16.9134348,7.65146143 15.125079,7.50511944 L15,7.5 L15,7.5 Z M17.5399796,7.94102339 L17.6028451,8.02030273 C18.7688344,9.56202556 19.5,12.1253041 19.5,15 C19.5,15.685365 19.45844,16.3530289 19.3793358,16.993368 C21.1982457,16.5325615 22.4025361,15.8148547 22.4943513,15.0890604 L22.5,15 C22.5,11.7494119 20.4320577,8.98181755 17.5399796,7.94102339 Z",
  id: "Combined-Shape",
  fill: "#D93252"
})));

const SvgIco30ReseauEquipmt = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30px",
  height: "30px",
  viewBox: "0 0 30 30",
  ref: svgRef
}, props), title === undefined ? _ref : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIco30ReseauEquipmt, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ico-30-reseauEquipmt.675d85ba.svg";
export { ForwardRef as ReactComponent };